import React, { useEffect, useState } from "react"
import { useHistory } from "react-router-dom"
import { Box, Button, Chip, Typography } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { ArrowBack, CreditCard, PersonOutline } from "@material-ui/icons"
import { useSnackbar } from "../../utils/notificacoes"
import Cabecalho from "../Cabecalho"
import { AlterarSenhaCliente } from "./components/AlterarSenhaCliente"
import { BloqueioCliente } from "./components/BloqueioCliente"
import { CartoesCliente } from "./components/CartoesCliente"
import { EnderecosCliente } from "./components/EnderecosCliente"
import { FormularioCliente } from "./components/FormularioCliente"
import { InteracoesCliente } from "./components/InteracoesCliente"
import { useEdicaoClienteContext } from "./context/useEdicaoClienteContext"

const useStyles = makeStyles(theme => ({
    container: {
        paddingLeft: "90px",
        paddingRight: "10px",
        paddingTop: "100px",
        paddingBottom: "30px",
        [theme.breakpoints.down("md")]: {
            paddingLeft: "20px",
            paddingRight: "20px",
            paddingTop: "80px",
        },
        [theme.breakpoints.down("sm")]: {
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingTop: "70px",
        },
    },
    content: {
        margin: "auto",
        maxWidth: "1100px",
        [theme.breakpoints.down("sm")]: { maxWidth: "100%" },
    },
    titleRow: {
        display: "flex",
        alignItems: "center",
        flexWrap: "wrap",
        gap: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
    iconHeader: {
        color: "#4caf50",
        marginRight: theme.spacing(1),
        fontSize: "2rem",
    },
    titleText: {
        fontWeight: 600,
        color: "#2c3e50",
        [theme.breakpoints.down("sm")]: { fontSize: "1.5rem" },
        [theme.breakpoints.down("xs")]: { fontSize: "1.25rem" },
    },
    subtitleText: {
        color: "#7f8c8d",
        marginBottom: theme.spacing(3),
    },
    acoesTopo: {
        display: "flex",
        flexWrap: "wrap",
        gap: theme.spacing(1),
        marginBottom: theme.spacing(3),
    },
}))

export function EdicaoCliente() {
    const classes = useStyles()
    const history = useHistory()
    const { dados, erroCarregamento } = useEdicaoClienteContext()
    const { enqueueSnackbar } = useSnackbar()

    const [cartoesAbertos, setCartoesAbertos] = useState(false)

    useEffect(() => {
        if (erroCarregamento) {
            enqueueSnackbar(erroCarregamento, { variant: "error" })
        }
    }, [erroCarregamento])

    return (
        <>
            <Cabecalho pagina="Edição de Cliente" />
            <Box className={classes.container}>
                <Box className={classes.content}>
                    <Box className={classes.titleRow}>
                        <PersonOutline className={classes.iconHeader} />
                        <Typography variant="h5" className={classes.titleText}>
                            Edição de Dados do Cliente{dados.nome ? `: ${dados.nome}` : ""}
                        </Typography>
                        {dados.carregado && !dados.ativo && (
                            <Chip label="Bloqueado" size="small" color="secondary" />
                        )}
                    </Box>
                    <Typography variant="body2" className={classes.subtitleText}>
                        Nessa tela você consegue visualizar e editar dados cadastrados do cliente,
                        interagir com ele e até mesmo bloqueá-lo ou excluí-lo.
                    </Typography>

                    <Box className={classes.acoesTopo}>
                        <Button
                            variant="outlined"
                            startIcon={<ArrowBack />}
                            onClick={() => history.push("/clientes")}
                        >
                            Voltar
                        </Button>
                        <Button
                            variant="outlined"
                            color="primary"
                            startIcon={<CreditCard />}
                            onClick={() => setCartoesAbertos(true)}
                        >
                            Cartões Cadastrados
                        </Button>
                    </Box>

                    {dados.carregado && dados.usuarioSimplificado ? (
                        <Typography variant="body1" style={{ color: "#7f8c8d" }}>
                            Este é um cliente genérico (cadastrado pelo sistema) e não pode ser
                            editado por esta tela. Para bloqueá-lo, use os pedidos realizados.
                        </Typography>
                    ) : (
                        <>
                            <FormularioCliente />
                            <InteracoesCliente />
                            <EnderecosCliente />
                            <AlterarSenhaCliente />
                            <BloqueioCliente />
                        </>
                    )}

                    <CartoesCliente
                        aberto={cartoesAbertos}
                        aoFechar={() => setCartoesAbertos(false)}
                    />
                </Box>
            </Box>
        </>
    )
}
